import React from "react";

import assetify from "@quintype/framework/assetify";
import DesktopLogo from "../../../../assets/images/NL-new-logo.svg";
import HindiLogo from "../../../../assets/images/hindi-logo.png";
import MobileLogo from "../../atoms/icons/mobile-logo";

import "./publihser-logo.m.css";

export function Logo() {
  const [isHindi, setIsHindi] = React.useState();
  React.useEffect(() => {
    setIsHindi(global.location.host.includes("hindi."));
  }, []);
  return (
    <React.Fragment>
      <div className="desktop-only ">
        {!isHindi ? (
          <img
            src={assetify(DesktopLogo)}
            loading="lazy"
            alt="Newslaundry"
            width="250px"
          />
        ) : (
          <img
            src={assetify(HindiLogo)}
            loading="lazy"
            alt="Newslaundry"
            width="160px"
          />
        )}
      </div>
      <div className="mobile-only" styleName="logo-margin">
        <MobileLogo />
      </div>
    </React.Fragment>
  );
}
